import { createExportColumnHelper } from 'components/DataExpansionComponents/Common/commonColumnHelpers'
import { getCommonChainProxyExportColumns } from 'components/DataExpansionComponents/Common/commonExportColumns'
import { CONVENIENCE_COLUMNS } from 'components/DataExpansionComponents/GooglePlaces/Convenience/ConvenienceColumnsInfo'
import { buildTargetExportModal } from './TargetExportModal'

const convenienceColumnHelper = createExportColumnHelper({
  columns: CONVENIENCE_COLUMNS,
})

export default buildTargetExportModal({
  targetType: 'cstore',
  isDoors: false,
  title: 'Select Columns for Convenience Stores Download',
  subTitle:
    'Download up to 10,000 convenience stores at a time, with any of the following columns. Any filters already applied will remain active.',
  submitText: 'Export Convenience Stores',
  progressName: 'Exporting Convenience Stores...',
  downloadLabel: 'Convenience Opportunities',
  useColumnGroups: () => [
    {
      title: 'Target Attributes',
      elements: [
        convenienceColumnHelper.retrieveColumn('name'),
        convenienceColumnHelper.retrieveColumn('city_summary'),
        convenienceColumnHelper.retrieveColumn('state_summary'),
        convenienceColumnHelper.retrieveColumn('zipcode_summary'),
        convenienceColumnHelper.retrieveColumn('domain'),
        convenienceColumnHelper.retrieveColumn('reviews_avg'),
        convenienceColumnHelper.retrieveColumn('reviews_cnt'),
        convenienceColumnHelper.retrieveColumn('open_hours'),
        convenienceColumnHelper.retrieveColumn('doors_cnt'),
      ],
    },
    {
      title: 'Predicted Values and Deals',
      elements: getCommonChainProxyExportColumns(),
    },
  ],
})
